import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'fixed right-5 bottom-5 z-[10000] w-[375px]',
    card: 'relative bg-white px-4 pt-4 pb-8 shadow-[0px_4px_11px_0px_rgba(29,31,34,0.1)]',
    drawerContent: 'pt-4 pb-8',
    skip: 'text-icon-main flex w-full cursor-pointer items-center justify-end',
    skipIcon: 'size-8',
    title: 'heading-xl mb-3',
    description: 'heading-xs mb-6 leading-[1.45] font-light',
    link: 'underline underline-offset-3',
    buttons: 'flex gap-3',
    button: 'w-full'
  }
});
